import { isElement } from '@udecode/plate';
import {
  BufferBlockElement,
  BufferInlineChildren,
  PlainText,
} from '~/editor/BufferEditor/types.plate';
import { NEW_LINE_REGEX } from '../constants';

export const PARAGRAPH_ELEMENT_TYPE = 'p';

export interface ParagraphElement extends BufferBlockElement {
  type: typeof PARAGRAPH_ELEMENT_TYPE;
  children: BufferInlineChildren | PlainText[];
}

export const ParagraphElement = {
  type: PARAGRAPH_ELEMENT_TYPE,
  is: (node: unknown) => {
    return isElement(node) && node.type === ParagraphElement.type;
  },
  new: (children: BufferInlineChildren | PlainText[]): ParagraphElement => {
    return {
      type: 'p',
      children,
    };
  },
  paragraphsFromText: (text: string): ParagraphElement[] => {
    return text
      .split(NEW_LINE_REGEX)
      .map((line) => ParagraphElement.new([{ text: line }]));
  },
};
